var testimonialCarousel = {
  init: function() {
    $('.js-testimonial-carousel').each(function (index, element) {
      var $carousel = $(element);
      var slideCount = $carousel.find('.gallery-cell').length;
      
      if (slideCount <= 1) {
        return;
      }

      // Cache elements for better performance
      var $section = $carousel.closest('.testimonial-carousel');
      var $prevButton = $section.find('.testimonial-carousel__nav-button--prev');
      var $nextButton = $section.find('.testimonial-carousel__nav-button--next');
      var $navContainer = $section.find('.testimonial-carousel__nav');

      if (!$carousel.hasClass('flickity-enabled')) {
        $carousel.flickity({
          cellAlign: 'left',
          contain: true,
          draggable: true,
          freeScroll: false,
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: false,
          wrapAround: false,
          autoPlay: false,
          selectedAttraction: 0.025,
          friction: 0.28,
          cellSelector: '.gallery-cell'
        });

        $carousel.addClass('testimonial-carousel-initialized');
        $section.addClass('initialized');

        function updateButtonStates() {
          var flkty = $carousel.data('flickity');
          if (!flkty) return;

          var canGoPrev = flkty.selectedIndex > 0;
          var canGoNext = flkty.selectedIndex < (flkty.slides.length - 1);

          $prevButton.prop('disabled', !canGoPrev);
          $nextButton.prop('disabled', !canGoNext);

          // Show/hide navigation based on whether it's needed
          var needsNavigation = slideCount > 1;
          $navContainer.toggle(needsNavigation);
        }

        // Event handlers with proper namespacing
        $prevButton.off('click.testimonialCarousel').on('click.testimonialCarousel', function(e) {
          e.preventDefault();
          $carousel.flickity('previous');
        });

        $nextButton.off('click.testimonialCarousel').on('click.testimonialCarousel', function(e) {
          e.preventDefault();
          $carousel.flickity('next');
        });

        // Consolidated event handlers
        $carousel.off('select.testimonialCarousel settle.testimonialCarousel keydown.testimonialCarousel')
                .on('select.testimonialCarousel', function() {
                  $carousel.find('.gallery-cell').removeAttr('aria-selected');
                  updateButtonStates();
                })
                .on('settle.testimonialCarousel', function() {
                  $carousel.find('.gallery-cell').removeAttr('aria-selected');
                  updateButtonStates();
                })
                .on('keydown.testimonialCarousel', function(e) {
                  if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    $carousel.flickity('previous');
                  } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    $carousel.flickity('next');
                  }
                });

        // Initial state
        $carousel.trigger('select.flickity');
        $carousel.attr('tabindex', '0');

        // Optimized resize handler
        var resizeTimeout;
        $(window).off('resize.testimonialCarousel').on('resize.testimonialCarousel', function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function() {
            if ($carousel.hasClass('flickity-enabled')) {
              $carousel.flickity('destroy');
              testimonialCarousel.init();
            }
          }, 300);
        });
      }
    });
  },

  unload: function($target) {
    var $carousel = $target.find('.js-testimonial-carousel');
    if ($carousel.hasClass('flickity-enabled')) {
      $carousel.flickity('destroy');
    }
    $(window).off('resize.testimonialCarousel');
  }
};

$(document).ready(function() {
  testimonialCarousel.init();
});

$(document).on('shopify:section:load', function(event) {
  testimonialCarousel.init();
});

$(document).on('shopify:section:unload', function(event) {
  testimonialCarousel.unload($(event.target));
});
